<template>
  <div class="active-question-root">
    <h2>{{ question.title }}</h2>
    <div
      v-if="question.questionImage"
      class="question-image"
    >
      <img :src="question.questionImage" alt="Question image">
    </div>
    <div class="answers-root">
      <div
        v-for="(answer, index) in question.answers"
        :key="answer.answer"
        class="answer"
        :class="{
          'true-answer': selectedAnswerPresent && trueAnswerIndex === index || selectedAnswer === index,
          'wrong-answer': selectedAnswerPresent && trueAnswerIndex !== index && selectedAnswer === index,
        }"
        @click="onAnswerSelect(answer)"
      >
        {{ answer.answer }}
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { indexOf, find } from "lodash";
export default {
  emits: ["answer-select"],
  props: {
    question: {
      type: Object,
      required: true,
    },
    selectedAnswer: {
      type: Number,
      default: null,
    },
  },
  setup(props, { emit }) {
    const selectedAnswer = computed(() => props.selectedAnswer);
    const selectedAnswerPresent = computed(() => selectedAnswer.value !== null);
    const trueAnswerIndex = computed(() => indexOf(props.question.answers, find(props.question.answers, { isCorrect: true })));
    const onAnswerSelect = (answer) => {
      if (selectedAnswerPresent.value) {
        return;
      }
      const selectedAnwerIndex = indexOf(props.question.answers, answer);
      emit("answer-select", {
        isAnswerCorrect: selectedAnwerIndex === trueAnswerIndex.value,
        selectedAnswerIndex: selectedAnwerIndex,
      });
    }
    return {
      selectedAnswer,
      selectedAnswerPresent,
      trueAnswerIndex,
      onAnswerSelect,
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.active-question-root {
  width: 100%;
  h2 {
    text-align: center;
    margin-bottom: 42px;
  }
  .question-image {
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
    padding-bottom: 1rem;
    img {
      width: 100%;
      object-fit: contain;
    }
  }
  .answers-root {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    color: #191414;
    .answer {
      width: 100%;
      background-color: rgba(255, 255, 255, .6);
      padding: 20px;
      cursor: pointer;
      border: 3px solid #626060;
      border-radius: 8px;
      color: #191414;
      font-weight: 500;
      font-size: 1.1rem;

      &.true-answer {
        border: 3px solid #191414;
        background-color: rgba(0, 113, 52, .65);
      }
      &.wrong-answer {
        border: 3px solid #191414;
        background-color: rgba(255, 2, 0, .55);
      }
    }
  }
}
</style>
